import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Nav } from "react-bootstrap";
import "./Nav.css";
import NavBarLogoFinal from "../../media/NavBarLogoFinal.svg";

interface AdminNavProps {
  isMobile: boolean;
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  handleLogout: () => void;
}

const AdminNav: React.FC<AdminNavProps> = ({
  isMobile,
  isSidebarOpen,
  toggleSidebar,
  handleLogout,
}) => {
  const [showOrdersDropdown, setShowOrdersDropdown] = useState(false);
  const [showVendorDropdown, setShowVendorDropdown] = useState(false);
  const [showMasterListDropdown, setShowMasterListDropdown] = useState(false);
  const [showReportsDropdown, setShowReportsDropdown] = useState(false);
  const [showAdminDropdown, setShowAdminDropdown] = useState(false);
  const [showInvoicingDropdown, setShowInvoicingDropdown] = useState(false);

  const toggleOrdersDropdown = () => {
    setShowOrdersDropdown(!showOrdersDropdown);
    setShowVendorDropdown(false);
    setShowMasterListDropdown(false);
    setShowReportsDropdown(false);
    setShowAdminDropdown(false);
    setShowInvoicingDropdown(false);
  };

  const toggleVendorDropdown = () => {
    setShowVendorDropdown(!showVendorDropdown);
    setShowOrdersDropdown(false);
    setShowMasterListDropdown(false);
    setShowReportsDropdown(false);
    setShowAdminDropdown(false);
    setShowInvoicingDropdown(false);
  };

  const toggleMasterListDropdown = () => {
    setShowMasterListDropdown(!showMasterListDropdown);
    setShowOrdersDropdown(false);
    setShowVendorDropdown(false);
    setShowReportsDropdown(false);
    setShowAdminDropdown(false);
    setShowInvoicingDropdown(false);
  };

  const toggleReportsDropdown = () => {
    setShowReportsDropdown(!showReportsDropdown);
    setShowOrdersDropdown(false);
    setShowVendorDropdown(false);
    setShowMasterListDropdown(false);
    setShowAdminDropdown(false);
    setShowInvoicingDropdown(false);
  };

  const toggleAdminDropdown = () => {
    setShowAdminDropdown(!showAdminDropdown);
    setShowOrdersDropdown(false);
    setShowVendorDropdown(false);
    setShowMasterListDropdown(false);
    setShowReportsDropdown(false);
    setShowInvoicingDropdown(false);
  };

  const toggleInvoicingDropdown = () => {
    setShowInvoicingDropdown(!showInvoicingDropdown);
    setShowOrdersDropdown(false);
    setShowVendorDropdown(false);
    setShowMasterListDropdown(false);
    setShowReportsDropdown(false);
    setShowAdminDropdown(false);
  };

  return (
    <div className={`sidebar ${isSidebarOpen ? "open" : "closed"}`}>
      {isMobile && (
        <div className="mobile-header">
          <div className="hamburger-button" onClick={toggleSidebar}>
            &#9776;
          </div>
          {isSidebarOpen && (
            <img
              src={NavBarLogoFinal}
              alt="Oxford Logo"
              className="sidebar-logo"
              // onClick={() =>
              //   window.open("https://www.oxforddoc.com/", "_blank")
              // }
            />
          )}
        </div>
      )}

      {isSidebarOpen && (
        <>
          {!isMobile && (
            <div className="sidebar-header">
              <img
                src={NavBarLogoFinal}
                alt="Oxford Logo"
                className="sidebar-logo"
                // onClick={() =>
                //   window.open("https://www.oxforddoc.com/", "_blank")
                // }
              />
            </div>
          )}
          <Nav className="flex-column">
            <Nav.Item>
              <Nav.Link
                as={Link}
                to="admin/orders/all"
                onClick={toggleOrdersDropdown}
                className="dropdown-toggle"
              >
                <i className="bi bi-pen-fill nav-icon" /> All Orders
              </Nav.Link>
              {showOrdersDropdown && (
                <Nav className="flex-column nested-nav">
                  <Nav.Link
                    className="child"
                    as={Link}
                    to="admin/orders/pending-orders"
                  >
                    Pending Orders
                  </Nav.Link>
                  <Nav.Link
                    className="child"
                    as={Link}
                    to="admin/orders/admin-review"
                  >
                    Admin Review
                  </Nav.Link>
                  <Nav.Link
                    className="child"
                    as={Link}
                    to="admin/orders/in-progress"
                  >
                    In Process
                  </Nav.Link>
                  <Nav.Link
                    className="child"
                    as={Link}
                    to="admin/orders/completed-orders"
                  >
                    Completed Orders
                  </Nav.Link>
                  <Nav.Link
                    className="child"
                    as={Link}
                    to="admin/orders/deleted-orders"
                  >
                    Deleted Orders
                  </Nav.Link>
                </Nav>
              )}
            </Nav.Item>

            <Nav.Item>
              <Nav.Link as={Link} to="admin/clients">
                <i className="bi bi-briefcase-fill nav-icon" />
                Clients
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                onClick={toggleReportsDropdown}
                className="dropdown-toggle"
              >
                <i className=" bi bi-file-earmark-text-fill nav-icon" />
                Reports
              </Nav.Link>
              {showReportsDropdown && (
                <Nav className="flex-column nested-nav">
                  <Nav.Link
                    className="child"
                    as={Link}
                    to="admin/reports/reference-tracking"
                  >
                    Reference Tracking
                  </Nav.Link>
                  <Nav.Link
                    className="child"
                    as={Link}
                    to="admin/reports/close-orders"
                  >
                    Close Orders
                  </Nav.Link>
                </Nav>
              )}
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="admin/invoicing"
                onClick={toggleInvoicingDropdown}
                className="dropdown-toggle"
              >
                <i className=" bi bi-bank nav-icon" />
                Invoicing
              </Nav.Link>
              {showInvoicingDropdown && (
                <Nav className="flex-column nested-nav">
                  <Nav.Link
                    className="child"
                    as={Link}
                    to="admin/invoicing/subscription-orders"
                  >
                    Subscription Orders
                  </Nav.Link>
                </Nav>
              )}
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                onClick={toggleVendorDropdown}
                className="dropdown-toggle"
              >
                <i className="bi bi-inboxes-fill nav-icon" />
                Vendor Research
              </Nav.Link>
              {showVendorDropdown && (
                <Nav className="flex-column nested-nav">
                  <Nav.Link
                    className="child"
                    as={Link}
                    to="admin/vendor/orders"
                  >
                    Vendor / Processing
                  </Nav.Link>
                  <Nav.Link
                    className="child"
                    as={Link}
                    to="admin/vendor/pending-vendor-orders"
                  >
                    Pending Orders
                  </Nav.Link>
                  <Nav.Link
                    className="child"
                    as={Link}
                    to="admin/vendor/review-queue"
                  >
                    Review Queue
                  </Nav.Link>
                </Nav>
              )}
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                onClick={toggleMasterListDropdown}
                className="dropdown-toggle"
              >
                <i className="bi bi-file-person-fill nav-icon" />
                Master Lists
              </Nav.Link>
              {showMasterListDropdown && (
                <Nav className="flex-column nested-nav">
                  <Nav.Link
                    className="child"
                    as={Link}
                    to="admin/master-lists/bishops"
                  >
                    Bishops
                  </Nav.Link>
                  <Nav.Link
                    className="child"
                    as={Link}
                    to="admin/master-lists/schools"
                  >
                    Schools
                  </Nav.Link>
                </Nav>
              )}
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                onClick={toggleAdminDropdown}
                className="dropdown-toggle"
              >
                <i className="bi bi-gear-wide-connected nav-icon" />
                Admin
              </Nav.Link>
              {showAdminDropdown && (
                <Nav className="flex-column nested-nav">
                  <Nav.Link className="child" as={Link} to="admin/email">
                    Email
                  </Nav.Link>
                  <Nav.Link
                    className="child"
                    as={Link}
                    to="admin/merge-clients"
                  >
                    Merge Clients
                  </Nav.Link>
                  <Nav.Link
                    className="child"
                    as={Link}
                    to="admin/edit-defaults"
                  >
                    Edit Defaults
                  </Nav.Link>
                  <Nav.Link
                    className="child"
                    as={Link}
                    to="admin/recent-activity"
                  >
                    Recent Activity
                  </Nav.Link>
                </Nav>
              )}
            </Nav.Item>

            <Nav.Item>
              <Button
                onClick={handleLogout}
                variant="outline-light"
                className="signout-button"
              >
                Sign Out <i className="bi bi-box-arrow-right sign-out-icon"></i>
              </Button>
            </Nav.Item>
          </Nav>
        </>
      )}
    </div>
  );
};

export default AdminNav;
